import { Injectable } from '@angular/core';
import { EventType } from '../models/vr-events/EventType';

@Injectable({
  providedIn: 'root'
})
export class VrEventTypeService {

  public types: EventType[];
  constructor() { }

  getType(eventTypeId: number): string {
    return this.types.filter(s => s.eventTypeId == eventTypeId)[0].type;
  }
}
